import MainBar from './main-bar';

interface SiteHeaderProps {
    showNavBar: boolean;
}

export default function SiteHeader(props: SiteHeaderProps) {
    return <>{props.showNavBar && <MainBar></MainBar>}</>;
}
